export const GET_FIELDS_SUCCESS = "GET_FIELDS_SUCCESS";
export const GET_FIELDS_ERROR = "GET_FIELDS_ERROR";
export const GET_VALIDATION_META_SUCCESS = "GET_VALIDATION_META_SUCCESS";
export const GET_VALIDATION_META_ERROR = "GET_VALIDATION_META_ERROR";
export const SAVE_VALIDATION_SUCCESS = "SAVE_VALIDATION_SUCCESS";
export const SAVE_VALIDATION_ERROR = "SAVE_VALIDATION_ERROR";
export const GENERATE_VALIDATION_SUCCESS = "GENERATE_VALIDATION_SUCCESS";
export const GENERATE_VALIDATION_ERROR = "GENERATE_VALIDATION_ERROR";
export const GET_VALIDATIONS_SUCCESS = "GET_VALIDATIONS_SUCCESS";
export const GET_VALIDATIONS_ERROR = "GET_VALIDATIONS_ERROR";
export const SET_VALIDATION_REDUCER = "SET_VALIDATION_REDUCER";
